<template>
	<div>
     <!--  menu Modal -->
     <div id="menuModal" class="modal fade" role="dialog" style="margin-top:7em">
        <div class="modal-dialog">

          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header" style="border-bottom-color:transparent; margin-bottom:2em;">
              <button type="button" class="close" data-dismiss="modal"><span style="font-size: 3em;">&times;</span></button>
             
            </div>
            <div class="modal-body">
              <ul class="sp-menu-list" v-if="loggedIn">
                  <li><a href="account">Hello {{user}}</a></li>
                  <li><a href="create">Create A Sellpoint</a></li>
                  <li><a href="account">My Account</a></li>
                  <li><a href="cart">View Cart <i class="fa fa-shopping-cart"></i></a></li>
                  <li><a href="orders">My Orders</a></li>
                  <li><a href="login">Log Out</a></li>
              </ul>
              <ul class="sp-menu-list"  v-else>
                  <li><a href="create">Create A Sellpoint</a></li>
                  <li><a href="login">Login</a></li>
                  <li><a href="register">Register</a></li>
              </ul>
            </div>
            <!-- <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
            </div> -->
          </div>

        </div>
     </div>
    <!-- /. Menu Modal -->
    </div>
</template>
<script>
import services from './../services/service'; // Service Class
let service = new services();

export default {
   name: 'MenuModal',
    
    data () {
        return {
           user:{},
           loggedIn:false,
        }
    },
    methods: {
        checkLoggedIn(){
            if(localStorage.getItem("sp_token") != null){
                this.loggedIn = true;
                this.user = localStorage.getItem("sp_user");
            }
        },
    },
  
    created(){
        this.checkLoggedIn()
    }
}
</script>


// WEBPACK FOOTER //
// menumodal.vue?17f9e54e